<template>
  <div>
    <div class="form-wrap">
      <div class="form-list py-2">

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.email.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[4][2]" :isHtml="true"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="email" value="" placeholder="abc@abc.com" v-model="input.email" @change="$v.input.email.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.email" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[4][1]"/></input-feedback>
            <input-feedback :validate-for-input="$v.input.email" type="email"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[4][2]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.password.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[4][3]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="password" value="" placeholder="********" v-model.trim="input.password" @change="$v.input.password.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.password" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[4][3]"/></input-feedback>
            <input-feedback :validate-for-input="$v.input.password" type="alphaNum"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[4][4]"/></input-feedback>
            <input-feedback :validate-for-input="$v.input.password" type="minLength"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[4][5]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 補足説明-->
        <div class="row pt-1 form-description-area text-center">
          <ul class="col-12 list-unstyled">
            <li>
              <a href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[4][4]"/> <i class="fa fa-files-o"></i></a>
            </li>
          </ul>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 補足説明-->
        <div class="row pt-1 form-description-area text-center">
          <p class="col-12 mb-0">
            <trans-text i18nKey="ui[4][7]"/>
          </p>
          <ul class="col-12 list-unstyled text-center">
            <li>
              <router-link :to="{ name: 'password-remind-from', params: {} }">
                <trans-text i18nKey="ui[4][8]"/>
              </router-link>
            </li>
          </ul>
          <p class="col-12">
            <i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="ui[4][9]" :isHtml="true"/>
          </p>
        </div>
      </div>
    </div>

    <!-- フォーム送信UI -->
    <div class="row text-center">
      <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
        <div class="my-4">
          <button type="button" class="btn w-100 btn-lg btn-danger" @click="tryForm"><trans-text i18nKey="ui[4][5]"/></button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum} from 'systems/validators'

  export default {
    extends:FormPartialBase,
    components: {
    },
    props:{
      user:Object,
    },
    data () {
      return {
        input: {
          email: "",
          password: "",
        }
      }
    },
    validations: {
      input: {
        email: {
          required,
          email,
        },
        password: {
          required,
          alphaNum,
          minLength: minLength(8),
        },
      },
    },
    created(){
    },
    methods:{
      tryForm(e){
        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }
        this.$emit('tryForm', this.input)
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// PageForm.vue?2ad00cef